import React, {useEffect} from 'react';
import {useQuery} from "@apollo/react-hooks";
import {GET_TASKS} from "../../database/queries/taskQueries";
import {notify} from "../../utils/notify";
import usePersistentStore from "../../persistentStore";

// const getTaskType = value => {
//     switch (value) {
//         case 'call':
//             return 'Call';
//         case 'email':
//             return 'Email';
//         case 'text':
//             return "Text Message";
//         default:
//             return "Unknown";
//     }
// };
//
// const getTaskStatus = value => {
//     switch (value) {
//         case 'not_started':
//             return 'Not Started';
//         case 'in_progress':
//             return 'In Progress';
//         case 'on_hold':
//             return "On Hold";
//         case 'completed':
//             return "Completed";
//         case 'cancelled':
//             return "Cancelled";
//         default:
//             return "Unknown";
//     }
// };

const TaskKanban = props => {
    const [globalPersistentState] = usePersistentStore();

    const {error: getTasksError, data: getTasksData, refetch: getTasksRefetch} = useQuery(GET_TASKS, {
        // skip: props.match.params.taskId,
        variables: {
            parentType: props.editType ? props.editType : null,
            parentId: props.editId ? props.editId : null,
            shareCategoryType: props.shareCategoryType ? props.shareCategoryType : 'personal',
            shareCategoryId: props.shareCategoryId ? props.shareCategoryId : 'personal',
            searchStr: null,
            // limit: 10,
            // offset: 0,
            // showCompleted: showCompleted,
            orderList: ['updatedAt DESC']
        },
    });

    useEffect(() => {
        if (!globalPersistentState.task) getTasksRefetch();
    }, [getTasksRefetch, globalPersistentState.task]);

    useEffect(() => {
        if (getTasksError) notify('getTasksError', 'error', getTasksError.message);
    }, [getTasksError]);

    useEffect(() => {
        if (getTasksData && getTasksData.tasks) {
            // let myTasks = [];
            getTasksData.tasks.map(task => {
                let myTask = {...task};
                if (myTask.account) {
                    myTask.entityType = 'Account';
                    myTask.entityName = myTask.account.accountName;
                } else if (myTask.contact) {
                    myTask.entityType = 'Contact';
                    myTask.entityName = myTask.contact.contactLastFirstName;
                } else if (myTask.project) {
                    myTask.entityType = 'Project';
                    myTask.entityName = myTask.project.projectName;
                } else {
                    myTask.entityType = 'General';
                }
                // myTasks.push(myTask);
                return myTask;
            });
            // setSelectedRows([]);
            // setSelectedObj({});
            // setTasks(myTasks);
        }
    }, [getTasksData]);

    return (
        <div>Kanban not implemented yet</div>
    )
};

export default TaskKanban
